export const themes = {
  default: {
    cssVariables: {
      buttonBorderRadius: "4px",
      inputFieldBorderColor: "#dcdfe4",
      "loader-message-color": "#4b5563",
      "loader-spinner-color": "#1976d2",
    },
    cssClasses: {},
  },
  themeSynaptrixDemo: {
    cssVariables: {
      buttonBorderRadius: "4px",
      inputFieldBorderColor: "#dcdfe4",
    },
    cssClasses: {},
  },
  themeCancelForAmerigas: {
    cssVariables: {
      buttonBorderRadius: "4px",
      inputFieldBorderColor: "#dcdfe4",
    },
    cssClasses: {},
  },
  themeSynaptrixDemoPartnerTelehealth: {
    cssVariables: {
      buttonBorderRadius: "4px",
      inputFieldBorderColor: "#dcdfe4",
    },
    cssClasses: {},
  },
  themeCancelForPartnerTelehealth: {
    cssVariables: {
      buttonBorderRadius: "4px",
      inputFieldBorderColor: "#dcdfe4",
    },
    cssClasses: {},
  },
  themeSynaptrixDemoForCpap: {
    cssVariables: {
      primary: "rgb(108,189,69)",
      primaryLight: "rgba(108,189,69,0.6)",
      buttonBorderRadius: "20px",
      inputFieldBorderColor: "rgb(108,189,69)",
    },
    cssClasses: {},
  },
  themeCancelForCPAP: {
    cssVariables: {
      primary: "rgb(108,189,69)",
      primaryLight: "rgba(108,189,69,0.6)",
      buttonBorderRadius: "20px",
      inputFieldBorderColor: "rgb(108,189,69)",
    },
    cssClasses: {},
  },
  theme1: {
    cssVariables: {
      primary: "#247bff",
      primaryLight: "rgba(36, 123, 255, 0.6)",
      buttonBorderRadius: "4px",
      inputFieldBorderColor: "#dcdfe4",
    },
    cssClasses: {},
  },
  theme2: {
    cssVariables: {
      primary: "#f79420",
      primaryLight: "rgba(247,148,32,0.6)",
      buttonBorderRadius: "4px",
      inputFieldBorderColor: "#dcdfe4",
      "primary-text-color": "#f79420",
      // primary: "rgb(35, 23, 81)",
      // primaryLight: "rgba(35, 23, 81, 0.6)",
      // "primary-text-color": "rgb(35, 23, 81)",
    },
    cssClasses: {},
  },
  theme3: {
    cssVariables: {
      primary: "#f79420",
      primaryLight: "rgba(247,148,32,0.6)",
      buttonBorderRadius: "4px",
      inputFieldBorderColor: "#dcdfe4",
    },
    cssClasses: {},
  },
  theme4: {
    cssVariables: {
      primary: "rgb(108,189,69)",
      primaryLight: "rgba(108,189,69,0.6)",
      buttonBorderRadius: "20px",
      inputFieldBorderColor: "rgb(108,189,69)",
    },
    cssClasses: {},
  },
  alternaSleep: {
    cssVariables: {
      buttonBorderRadius: "4px",
      inputFieldBorderColor: "#dcdfe4",
      conditionalBorderColor: "#0699EF",
      inputFillColor: "#0699EF",
      primary: "#0699EF",
      primaryLight: "rgba(6,153,239,0.6)",
      "loader-message-color": "#ffffff",
      "loader-spinner-color": "#ffffff",
    },
    cssClasses: {},
  },
  midwestDental: {
    cssVariables: {
      buttonBorderRadius: "8px",
      inputFieldBorderColor: "#e5e7eb",
      primary: "#352B67",
      primaryLight: "rgba(53,43,103,0.6)",
      "primary-text-color": "#352B67",
      conditionalBorderColor: "#352B67",
      inputFillColor: "#352B67",
      "primary-background-color": "#352B67"
    },
    cssClasses: {},
  },
};
